import React from "react";
import LogoLeft from "../../assets/images/logo_half_right.png";
import LogoRight from "../../assets/images/logo_half_left.png";
import LogoFull from "../../assets/images/logo_full_light.png";
import WhiteCover from "../WhiteCover/WhiteCover";
import "./CompanyPoliciesList.scss";

export default function CompanyPoliciesList() {
  const policies = [
    {
      name: "JJSS Data Protection Policy",
      file: "/pdfs/JJSS_DATA_PROTECTION_POLICY.pdf",
    },
    {
      name: "JJSS Environmental Policy",
      file: "/pdfs/JJSS_ENVIRONMENTAL_POLICY.pdf",
    },
    {
      name: "JJSS Equality and Diversity Policy",
      file: "/pdfs/JJSS_EQUALITY_0DIVERSITY_POLICY.pdf",
    },
    {
      name: "JJSS Safeguarding Policy",
      file: "/pdfs/JJSS_SAFEGUARDING_POLICY.pdf",
    },
    {
      name: "JJSS Modern Slavery and Human Trafficking",
      file: "/pdfs/JJSS_MODERN_SLAVERY_0HUMAN_TRAFFICKING.pdf",
    },
    {
      name: "JJSS Health and Safety Policy",
      file: "/pdfs/JJSS_HEALTH_0SAFETY_POLICY.pdf",
    },
    {
      name: "JJSS Business Continuity Plan",
      file: "/pdfs/JJSS_BCP_POLICY.pdf",
    },
    {
      name: "JJSS Carbon Reduction Policy",
      file: "/pdfs/JJSS_CARBON_REDUCTION_POLICY.pdf",
    },
    {
      name: "JJSS Risk Assessment Policy",
      file: "/pdfs/JJSS_RISK_ASSESSMENT_POLICY.pdf",
    },
    {
      name: "JJSS Privacy Policy",
      file: "/pdfs/JJSS_PRIVACY_POLICY.pdf",
    },
    {
      name: "JJSS Mission Statement Policy",
      file: "/pdfs/JJSS_MISSION_STATEMENT_POLICY.pdf",
    },
    {
      name: "JJSS Compliance Management System Policy",
      file: "/pdfs/JJSS_Compliance_Management_Systems_Policy.pdf",
    },
  ];

  return (
    <WhiteCover
      className={"d-flex flex-dir-col mt-4 mb-4 pt-4 pb-4 policies-container"}
      style={{ backgroundColor: "white" }}
    >
      <div className="image-left">
        <img src={LogoLeft} alt="Career" />
      </div>
      <div className="image-right">
        <img src={LogoRight} alt="Career" />
      </div>
      <div className="image-full small">
        <img src={LogoFull} alt="Career" />
      </div>
      <div className="policy-list" style={{ zIndex: 99999 }}>
        <ol
          style={{
            textAlign: "center",
            listStylePosition: "inside",
            padding: 0,
            margin: "0 auto",
            maxWidth: "700px",
          }}
        >
          {policies.map((policy, index) => (
            <li
              key={index}
              style={{
                fontSize: "20px",
                fontWeight: 500,
                margin: "10px 0",
              }}
            >
              <a
                href={policy.file}
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "#2d1b4e",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {policy.name}
              </a>
            </li>
          ))}
        </ol>
      </div>
    </WhiteCover>
  );
}
